/*
 * @Author: Hao Zhou (hao.zhou@ringcentral.com)
 * @Date: 2023-03-14 08:53:05
 * Copyright © RingCentral. All rights reserved.
 */

import { precacheAndRoute, addPlugins } from 'workbox-precaching';

/* eslint-disable no-undef */
precacheAndRoute(self.__WB_MANIFEST);

addPlugins([
  {
    requestWillFetch: function ({ request }) {
      return new Request(request, {
        headers: {
          ...request.headers,
          /* eslint-disable no-undef */
          'x-sw-jrc-version': APP_VERSION,
        },
      });
    },
  },
]);
